import { SVGProps, Ref, forwardRef } from 'react';

export const EmptySize96Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={96} height={96} viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <rect x={-1} y={-1} width={98} height={98} stroke="currentColor" strokeWidth={2} />
            </g>
        </g>
    </svg>
));
EmptySize96Glyph.displayName = 'EmptySize96Glyph';
